import axios from 'axios';
import { createErrorToast } from '@arc/frontend/ui-toasts';
import { isNotNullish } from '@arc/shared/util-js';

/**
 * Attempt to get a request id from an error. Returns `null` when a request id is not found.
 */
function getRequestId(response) {
  const requestId = response?.headers?.['x-request-id'];
  if (typeof requestId === 'string') {
    return requestId;
  }
  return null;
}
/**
 * Global handler for errors returned from external requests.
 * Currently:
 *  - Shows error toast
 *  - Shows error in console
 */
export function handleRequestErrors(errors, options) {
  const requestIds = errors.filter(axios.isAxiosError).map(e => getRequestId(e.response)).filter(isNotNullish);
  createErrorToast(options.errorMessage, {
    errorCodes: requestIds
  });
  for (const err of errors) {
    console.error(options.errorMessage, err);
  }
}